// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let QueryString = require("query-string");
let UseQueryParams = require("use-query-params");

function withHiddenDefault(m, $$default) {
  let M = UseQueryParams.withDefault(m, $$default);
  let encode = x => {
    if (x === $$default) {
      return;
    } else {
      return M.encode(x);
    }
  };
  return {
    encode: encode,
    decode: M.decode
  };
}

function hide(m) {
  return m;
}

let stringParam = UseQueryParams.StringParam;

let numberParam = UseQueryParams.NumberParam;

let arrayParam = UseQueryParams.ArrayParam;

let booleanParam = UseQueryParams.BooleanParam;

function Make(M) {
  let use = () => {
    let match = UseQueryParams.useQueryParams(M.config);
    let setState = match[1];
    let setState$p = (updateType, s) => setState(s, updateType);
    return [
      match[0],
      setState$p
    ];
  };
  let encode = params => UseQueryParams.encodeQueryParams(M.config, params);
  return {
    use: use,
    encode: encode
  };
}

function Make$1(M) {
  let use = key => {
    let match = UseQueryParams.useQueryParam(key, M);
    let setState = match[1];
    let setState$p = (updateType, s) => setState(s, updateType);
    return [
      match[0],
      setState$p
    ];
  };
  return {
    use: use
  };
}

let UseQueryParam = {
  Make: Make$1
};

let QueryString$1 = {
  stringify: prim => QueryString.stringify(prim)
};

function encodeDelimitedArray(prim0, prim1) {
  return UseQueryParams.encodeDelimitedArray(prim0, prim1);
}

function decodeDelimitedArray(prim0, prim1) {
  return UseQueryParams.decodeDelimitedArray(prim0, prim1);
}

function ParamConfigs_withDefault(prim0, prim1) {
  return UseQueryParams.withDefault(prim0, prim1);
}

let ParamConfigs = {
  stringParam: UseQueryParams.StringParam,
  numberParam: UseQueryParams.NumberParam,
  arrayParam: UseQueryParams.ArrayParam,
  booleanParam: UseQueryParams.BooleanParam,
  withDefault: ParamConfigs_withDefault,
  withHiddenDefault: withHiddenDefault
};

let UseQueryParams_ParamConfigs = {
  stringParam: stringParam,
  numberParam: numberParam,
  arrayParam: arrayParam,
  booleanParam: booleanParam,
  fromParamConfig: hide
};

let UseQueryParams$1 = {
  ParamConfigs: UseQueryParams_ParamConfigs,
  Make: Make
};

exports.QueryString = QueryString$1;
exports.encodeDelimitedArray = encodeDelimitedArray;
exports.decodeDelimitedArray = decodeDelimitedArray;
exports.ParamConfigs = ParamConfigs;
exports.UseQueryParams = UseQueryParams$1;
exports.UseQueryParam = UseQueryParam;
/* stringParam Not a pure module */
